import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
@Injectable({
    providedIn: 'root'
})
export class EcryptServiceService {



    secretKey;
    constructor() {
        this.secretKey = "abcd@ef#gh*I&jkl";
    }

    encrypt(value: any): string {
        const key = CryptoJS.enc.Utf8.parse(this.secretKey);
        const iv = CryptoJS.enc.Utf8.parse(this.secretKey);
        const src = JSON.stringify(value);
        const encrypted = CryptoJS.AES.encrypt(src, key, {
            keySize: 16,
            iv: iv,
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        }).toString();
        return encrypted.replace(/\+/g, 'xMl3Jk').replace(/\//g, 'Por21Ld').replace(/\=/g, 'Ml32');
    }

    decrypt(textToDecrypt: string) {
        return CryptoJS.AES.decrypt(textToDecrypt, this.secretKey.trim()).toString(CryptoJS.enc.Utf8);
    }

    encryptionAES (msg) {
        // Encrypt
        const ciphertext = CryptoJS.AES.encrypt(msg?.toString(), this.secretKey.trim());


        return ciphertext.toString().replace(/\+/g,'xMl3Jk').replace(/\//g,'Por21Ld').replace(/\=/g,'Ml32');
      }
    
      decryptionAES (msg) {
        // Decrypt
        if(msg){
            msg=msg.toString().replaceAll('xMl3Jk','+');
            msg=msg.toString().replaceAll('Por21Ld','/');
            msg=msg.toString().replaceAll('Ml32','=');
            const bytes  = CryptoJS.AES.decrypt(msg, this.secretKey.trim());
            const plaintext = bytes.toString(CryptoJS.enc.Utf8);
            return plaintext;
        }
  
      }
}
